// extracted by mini-css-extract-plugin
module.exports = {"FirstLink":"Main_FirstLink__2pZVB","Logo":"Main_Logo__23_0q","Item":"Main_Item__39eqo","Oblong":"Main_Oblong__3VN_G"};